import { useBookmarks } from "@circle-react-shared/Bookmarks/hooks/useBookmarks";

import { commentCache } from "@/react/lib/queries/comments";
import type { Comment } from "@/react/types/Comment";

interface UseBookmarkCommentParams {
  comment: Comment;
}

export const useBookmarkComment = ({ comment }: UseBookmarkCommentParams) => {
  const { id, post_id: postId, bookmark_id: bookmarkId } = comment;

  const { createBookmark, deleteBookmark } = useBookmarks({
    bookmarkId,
    bookmarkType: "comment",
    record: comment,
    onSuccess: nextBookmarkId =>
      commentCache.setBookmark({ postId, id, bookmarkId: nextBookmarkId }),
    disableFetch: true,
  });

  const toggleBookmark = () => {
    if (bookmarkId) deleteBookmark();
    else createBookmark();
  };

  return { toggleBookmark };
};
